import {KalmanFilter} from "kalman-filter";

const ConstantSpeedDynamicRange = function(t) {
    return new KalmanFilter({
        observation: {
            dimension: 2,
            /**
            * @param {State} opts.predicted
            * @param {Array.<Number>} opts.observation
            * @param {Number} opts.index
            */
            stateProjection: function() { // opts
                return [
                    [1, 0],
                    [0, 1]
                ];
            },
            /**
            * @param {State} opts.predicted
            * @param {Array.<Number>} opts.observation
            * @param {Number} opts.index
            */        
            covariance: function() { // opts
                return [
                    [1, 0],
                    [0, 1]
                ];
            }
        },
        dynamic: {
            dimension: 4, //(x, y, dx, dy)
            /**
            * @param {State} opts.previousCorrected
            * @param {Number} opts.index
            */
            transition: function(opts) {
                const dt = t[opts.index + 1] - t[opts.index];
                return [
                    [1, 0, dt, 0 ],
                    [0, 1, 0 , dt],
                    [0, 0, 1 , 0 ],
                    [0, 0, 0 , 1 ]
                ];
            },
            /**
            * @param {State} opts.previousCorrected
            * @param {Number} opts.index
            */        
            covariance: function(opts) {
                const dt = t[opts.index + 1] - t[opts.index];
                return [
                    [1, 0, 0     , 0     ],
                    [0, 1, 0     , 0     ],
                    [0, 0, 1 * dt, 0     ],
                    [0, 0, 0     , 1 * dt]
                ];
            }
        }
    });
};

export default ConstantSpeedDynamicRange;
